import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteDivisionMaster = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteGradeMasterId: '',
        divisionName: ['']
    }
    const [GradeList, setGradeList] = useState([])
    const [divisionData, setDivistionData] = useState(initialFormState)
    const [divisionList, setDivisionList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [divisionSort, setDivisionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteGradeMasterDetails.gradeName", "divisionName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList();
    }, []);

    useEffect(() => {
        getDivisionList();
    }, [divisionData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getDivisionList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (divisionData.instituteGradeMasterId !== '') {
                setDivisionList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(divisionList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(divisionList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > divisionList.length) {
            endIndex = divisionList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(divisionList.slice(startIndex, endIndex));
    }, [divisionList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-division?instituteMasterId=${instituteMasterId}&`;
        if (divisionData.instituteGradeMasterId) {
            apiUrl += `instituteGradeMasterId=${divisionData.instituteGradeMasterId}`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getDivisionList = async () => {
        if (divisionData.instituteGradeMasterId !== '') {
            try {
                const response = await authorizedAxiosInstitute.get(getApiUrl());
                setDivisionList(response.data.result);
            } catch (error) {
                setDivisionList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getGradeList = async () => {
        try {
            const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setGradeList(response.data.result)
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleClassChange = (e) => {
        setDivistionData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleInputChange = (e, index) => {
        setDivistionData((prevData) => {
            if (e.target.name === 'divisionName') {
                const updatedLessonName = [...prevData.divisionName];
                updatedLessonName[index] = e.target.value.toUpperCase();
                return {
                    ...prevData,
                    divisionName: updatedLessonName,
                };
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }
    
    const handleAddDivision = () => {
        setDivistionData((prevData) => ({
            ...prevData,
            divisionName: [...prevData.divisionName, ''],
        }));
    };

    const handleRemoveDivision = (index) => {
        setDivistionData((prevData) => {
            const updatedLessonName = [...prevData.divisionName];
            // Remove the element at the specified index
            updatedLessonName.splice(index, 1);
            return {
                ...prevData,
                divisionName: updatedLessonName,
            }
        });
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noErrors = Object.values(error).every((error) => error === '');
        const allValuesValid = Object.entries(divisionData).every(([key, value]) => {
            if (key === 'divisionName' && Array.isArray(value)) {
                return value.every(division => typeof division === 'string' && division.trim() !== '');
            } else {
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(divisionData)) {
                if (key === "divisionName") {
                    for (const division of divisionData.divisionName) {
                        if (division === '' || division.length === 0) {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    divisionName: 'This field is required.',
                                }
                            })
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    divisionName: '',
                                }
                            })
                        }
                    }
                } else if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [divisionData])

    const addDivision = async () => {
        if (validateForm()) {
            try {
                const apiUrl = `/add-institute-division`;
                setLoading(true);
                const response = await authorizedAxiosInstitute.post(apiUrl, divisionData);
                await getDivisionList();

                setDivistionData((prevData) => {
                    return {
                        ...prevData,
                        divisionName: ['']
                    }
                });

                setSaveId(response.data.result[0].id);
                setDivisionSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(divisionData)) {
                if (key === "divisionName") {
                    for (const division of divisionData.divisionName) {
                        if (division == '' || division.length == 0) {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    divisionName: 'This field is required.',
                                }
                            })
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    divisionName: '',
                                }
                            })
                        }
                    }
                } else if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteDivision = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-division?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, divisionList.length);
                await getDivisionList();
                // setRefresh(!refresh);
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateDivision = async () => {
        if (validateForm()) {
            try {
                const apiUrl = `/edit-institute-division?id=${editId}`;
                let data = {}
                setLoading(true);
                data.divisionName = divisionData.divisionName[0];
                const response = await authorizedAxiosInstitute.put(apiUrl, data);
                await getDivisionList();
                setEditId(null);
                setDivistionData(initialFormState);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(divisionData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Division Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-list"></i>Division Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select disabled={editId} class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleClassChange} value={divisionData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            GradeList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}
                                                </div>

                                                {divisionData?.divisionName?.map((lesson, index) => (
                                                    <>
                                                        <div className={divisionData?.divisionName?.length > 1 ? "col-md-5" : "col-md-6"}>
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Division Name :</label>
                                                            <input type="text" className="form-control" id={`divisionName${index}`} name='divisionName' onChange={(e) => handleInputChange(e, index)} value={lesson} />
                                                            {error.divisionName && lesson == "" && <p style={{ color: 'red' }}>{error.divisionName}</p>}
                                                        </div>
                                                        {divisionData.divisionName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveDivision(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" onClick={handleAddDivision}>+ Add Another Division Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addDivision}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" style={{ marginRight: "20px" }} type="button" onClick={() => { setEditId(''); setDivisionList([]); setDivistionData(initialFormState) }}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateDivision} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Class Name
                                                                        </th>
                                                                        <th scope="col">
                                                                            Division Name
                                                                            <SortIcon sortState={divisionSort} setSortState={setDivisionSort} setData={setDivisionList} setCurrPage={setCurrPage} sortingPath={"divisionName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.instituteGradeMasterDetails?.gradeName}</td>

                                                                                        <td>{lesson.divisionName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setDivistionData(prevData => {
                                                                                                    return {
                                                                                                        ...prevData,
                                                                                                        divisionName: [lesson.divisionName],
                                                                                                        instituteGradeMasterId: lesson.instituteGradeMasterId.toString()
                                                                                                    }
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === lesson.id} onClick={() => deleteDivision(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Division Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={divisionList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteDivisionMaster;